export default __webpack_public_path__ + "static/media/fotoJunto2.a8123a0e.jpg";